import React from 'react'
import { Box } from '@mui/material'
import CadsoftLogoImage from '../../assets/svg/logo.svg'

const CadsoftLogo = (props) => {
  return (
    <Box
      component="img"
      height={props.height}
      src={CadsoftLogoImage}
      width={props.width}
      alt="Cadsoft Logo"
      sx={{
        lineHeight: props.lineHeight,
        marginX: props.marginX,
        marginRight: props.marginRight,
        padding: props.padding,
        paddingX: props.paddingX,
      }}
    >
    </Box>
  )
}

export default CadsoftLogo